// Whether the in-house pipeline may SEND right now.
//   'send'  — flag on, no kill switches
//   'hold'  — flag state unknown (cache cold): keep queueing, don't send yet
//   'drop'  — flag off / kill switch / Cypress: discard
import { getFeatureFlagMap } from '@/hooks/useFeatureFlag';

export const FLAG_KEY = 'v2.2508.13_inhouse-web-analytics';
export const DISABLED_LS_KEY = 'analytics:disabled';

export type GateDecision = 'send' | 'hold' | 'drop';

export function gateDecision(): GateDecision {
  try {
    if (typeof window !== 'undefined' && window.Cypress) return 'drop';
    if (localStorage.getItem(DISABLED_LS_KEY) === '1') return 'drop';
  } catch {
    /* localStorage unavailable → fall through to flag check */
  }
  const map = getFeatureFlagMap();
  if (map === null) return 'hold';
  return map[FLAG_KEY] && map[FLAG_KEY] !== 'off' ? 'send' : 'drop';
}
